import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import Index from "./pages/index";
import ImportReports from "./pages/import/ImportReports";
import ImportCargo from "./pages/import/ImportCargo";
import ImportRevenue from "./pages/import/ImportRevenue";
import ImportAnalytics from "./pages/import/ImportAnalytics";
import ImportCycleReports from "./pages/import/ImportCycleReports";
import ImportJobs from "./pages/import/ImportJobs";
import ImportIndex from "./pages/import/ImportIndex";

import ExportReports from "./pages/export/ExportReports";
import ExportCargo from "./pages/export/ExportCargo";
import ExportRevenue from "./pages/export/ExportRevenue";
import ExportAnalytics from "./pages/export/ExportAnalytics";
import ExportCycleReports from "./pages/export/ExportCycleReports";
import ExportJobs from "./pages/export/ExportJobs";
import ExportIndex from "./pages/export/ExportIndex";
import Cargo_live_view from "./pages/export/Cargo_live_view";

import CustomsReports from "./pages/customs/CustomsReports";
import CustomsIndex from "./pages/customs/CustomsIndex";

import AuctionsIndex from "./pages/auctions/AuctionsIndex";
import AuctionsReports from "./pages/auctions/AuctionsReports";

import ConfigurationIndex from "./pages/configuration/Configurationndex";
import ConfigurationCamera from "./pages/configuration/ConfigurationCamera";
import ConfigurationToml from "./pages/configuration/ConfigurationToml";
import { useEffect } from "react";
// Export maps
import LCLWorkshopGroundFloor from "./pages/export/maps/LCLWorkshopGroundFloor";
import GSRackWarehouses from "./pages/export/maps/GSRackWarehouse";
import OldLCLWarehouse from "./pages/export/maps/OldLCLWarehouse";
import Login from "./pages/Login";
import PrivateRoute from "./PrivateRoute";
import Logout from "./pages/Logout";
import DeStuffingTallySheet from "./pages/import/DeStuffingTallySheet";
import DeliveryTallySheet from "./pages/import/DeliveryTallySheet";
import CartingTallySheet from "./pages/export/CartingTallySheet";
import StuffingTallySheet from "./pages/export/StuffingTallySheet";
import ImportEJO from "./pages/import/ImportEJO";
import ExportSJO from "./pages/export/ExportSJO";
import ExportSealed from "./pages/export/ExportSealed";
import { Suspense } from "react";
import MapTable from "./pages/import/maps/MapTable";
import ExportTable from "./pages/export/maps/ExportTable";
import MezzanineGroundFloorTable from "./pages/export/maps/MezzanineGroundFloorTable";
import CartingTallySheet2 from "./pages/export/CartingTallySheet2";
import DeStuffingTallySheet2 from "./pages/import/DeStuffingTallySheet2";
import Profile from "./pages/Profile";
import OycTable from "./pages/export/maps/OycTable";

export default function App() {

  const Map = React.lazy(() => import("./pages/import/maps/Map"));
  const MezzanineGroundFloor = React.lazy(() => import("./pages/export/maps/MezzanineGroundFloor"));
  const ExportWarehouse = React.lazy(() => import("./pages/export/maps/ExportWarehouse"));

  const initialTheme = sessionStorage.getItem("myTheme") === "true";
  useEffect(() => {
    const coreCss = document.querySelector(".template-customizer-core-css");
    const themeCss = document.querySelector(".template-customizer-theme-css");

    if (initialTheme) {
      document.documentElement.setAttribute("data-style", "dark");
      if (coreCss && themeCss) {
        coreCss.setAttribute("href", "/assets/vendor/css/rtl/core-dark.css");
        themeCss.setAttribute(
          "href",
          "/assets/vendor/css/rtl/theme-default-dark.css"
        );
      }
    } else {
      document.documentElement.setAttribute("data-style", "light");
      if (coreCss && themeCss) {
        coreCss.setAttribute("href", "/assets/vendor/css/rtl/core.css");
        themeCss.setAttribute(
          "href",
          "/assets/vendor/css/rtl/theme-default.css"
        );
      }
    }
  }, []);

  return (
    <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/Login" element={<Login />} />
          <Route path="/Logout" element={<Logout />} />
          <Route path="/Profile" element={<Profile />} />

          <Route path="/" element={<PrivateRoute><Index /></PrivateRoute>} />

          {/* ----------------- IMPORT  --------------------- */}
          <Route path="/import" element={<PrivateRoute><ImportIndex /></PrivateRoute>} />
          <Route path="/import-cargo" element={<PrivateRoute><ImportCargo /></PrivateRoute>} />
          <Route path="/import-reports" element={<PrivateRoute><ImportReports /></PrivateRoute>} />
          <Route  path="/import/jobs" element={<PrivateRoute><ImportJobs /></PrivateRoute> } />
          <Route path="/import-revenue" element={<PrivateRoute><ImportRevenue /></PrivateRoute>} />
          <Route path="/deStuffing/tallySheet" element={<PrivateRoute><DeStuffingTallySheet /></PrivateRoute>} />
          <Route path="/delivery/tallySheet" element={<PrivateRoute><DeliveryTallySheet /></PrivateRoute>} />
          <Route path="/import/map" element={<PrivateRoute><Suspense fallback={<div>Loading...</div>}><Map /></Suspense></PrivateRoute>}/>
          <Route path="/import/map/table" element={<PrivateRoute><MapTable /></PrivateRoute>} />
          <Route path="/deStuffing/tallySheet2" element={<PrivateRoute><DeStuffingTallySheet2 /></PrivateRoute>} />
          
         
          {/* ----------------- EXPORT  --------------------- */}
          <Route path="/export" element={<PrivateRoute><ExportIndex /></PrivateRoute>} />
          <Route path="/export-cargo" element={<PrivateRoute><ExportCargo /></PrivateRoute>} />
          <Route path="/export-reports" element={<PrivateRoute><ExportReports /></PrivateRoute>} />
          <Route  path="/export/jobs" element={<PrivateRoute><ExportJobs /></PrivateRoute> } />
          <Route path="/export-revenue" element={<PrivateRoute><ExportRevenue /></PrivateRoute>} />
          <Route path="/carting/tallySheet" element={<PrivateRoute><CartingTallySheet /></PrivateRoute>} />
          <Route path="/stuffing/tallySheet" element={<PrivateRoute><StuffingTallySheet /></PrivateRoute>} />
          <Route path="/ExportWarehouse" element={<PrivateRoute><Suspense fallback={<div>Loading...</div>}><ExportWarehouse /></Suspense></PrivateRoute>}/>
          <Route path="/MezzanineGroundFloor" element={<PrivateRoute><Suspense fallback={<div>Loading...</div>}><MezzanineGroundFloor /></Suspense></PrivateRoute>}/>
          <Route path="/MezzanineGroundFloorTable" element={<PrivateRoute><MezzanineGroundFloorTable /></PrivateRoute>} />
          <Route path="/ExportTable" element={<PrivateRoute><ExportTable /></PrivateRoute>} />
          <Route path="/OycTable" element={<PrivateRoute><OycTable /></PrivateRoute>} />
          <Route path="/carting/tallySheet2" element={<PrivateRoute><CartingTallySheet2 /></PrivateRoute>} />

          {/*
          <Route path="/import-ejo-jobs" element={<PrivateRoute><ImportEJO /></PrivateRoute>} /> 
          <Route path="/import-cycle-reports" element={<PrivateRoute><ImportCycleReports /></PrivateRoute>} />
          <Route path="/import-analytics" element={<PrivateRoute><ImportAnalytics /></PrivateRoute>} /> 

          <Route path="/cargo_live_view" element={<PrivateRoute><Cargo_live_view /></PrivateRoute>} />
          <Route path="/export-sjo-jobs" element={<PrivateRoute><ExportSJO /></PrivateRoute>} />
          <Route path="/export-sealed-jobs" element={<PrivateRoute><ExportSealed /></PrivateRoute>} />
          <Route path="/export-cycle-reports" element={<PrivateRoute><ExportCycleReports /></PrivateRoute>} />
          <Route path="/export-analytics" element={<PrivateRoute><ExportAnalytics /></PrivateRoute>} />

          <Route path="/LCLWorkshopGroundFloor" element={<PrivateRoute><LCLWorkshopGroundFloor /></PrivateRoute>} />
          <Route path="/GSRackWarehouse" element={<PrivateRoute><GSRackWarehouses /></PrivateRoute>} />
          <Route path="/OldLCLWarehouse" element={<PrivateRoute><OldLCLWarehouse /></PrivateRoute>} />
         
          <Route path="/customs" element={<PrivateRoute><CustomsIndex /></PrivateRoute>} />
          <Route path="/customs-reports" element={<PrivateRoute><CustomsReports /></PrivateRoute>} />

          <Route path="/auctions" element={<PrivateRoute><AuctionsIndex /></PrivateRoute>} />
          <Route path="/auctions-reports" element={<PrivateRoute><AuctionsReports /></PrivateRoute>} />

          <Route path="/configuration" element={<PrivateRoute><ConfigurationIndex /></PrivateRoute>} />
          <Route path="/configuration-camera-config" element={<PrivateRoute><ConfigurationCamera /></PrivateRoute>} />
          <Route path="/configuration-toml-config" element={<PrivateRoute><ConfigurationToml /></PrivateRoute>} /> 
          */}
        </Routes>
    </Router>
  );
}
